import * as e from "react";
import { c as s } from "../createReactComponent-58f9bea8.mjs";
import { a as o, r } from "../resize-handle-62b4d9ef.mjs";
import { R as z } from "../resize-handle-62b4d9ef.mjs";
import "../property-9daa16cd.mjs";
import "../class-map-2994e95e.mjs";
const n = s({ tagName: "ex-resize-handle", elementClass: o, react: e, events: { onResizeComplete: "onResizeComplete" }, displayName: "ExResizeHandle", registerWebComponent: r });
export {
  n as ExResizeHandle,
  z as ResizerPosition,
  r as register
};
